define('views/components/distributor_personal/distributor_personal_list',['require','views/base/list_view','views/components/distributor_personal/distributor_personal','text!templates/components/distributor_personal/distributor_personal_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/distributor_personal/distributor_personal');

    var temp = require("text!templates/components/distributor_personal/distributor_personal_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

